import { render } from "./ProjectInvoiceDropper.vue?vue&type=template&id=161c1570&scoped=true"
import script from "./ProjectInvoiceDropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInvoiceDropper.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInvoiceDropper.vue?vue&type=style&index=0&id=161c1570&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161c1570"],['__file',"src/components/tools/InvoiceDropper/ProjectInvoiceDropper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "161c1570"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('161c1570', __exports__)) {
    api.reload('161c1570', __exports__)
  }
  
  module.hot.accept("./ProjectInvoiceDropper.vue?vue&type=template&id=161c1570&scoped=true", () => {
    api.rerender('161c1570', render)
  })

}


export default __exports__